import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "permission"
})
export class PermissionPipe implements PipeTransform {
  // Demo for Pipe
  transform(input: string) {    
    if (input) { input = input.toLowerCase(); }
    let isAuthorized=true;
    let unAuthorizeList = localStorage.getItem("UnAuthorizedList");
    if (
      unAuthorizeList != undefined &&
      unAuthorizeList.indexOf("|" + input + "|") > -1
    ) {
      isAuthorized= false;
    }
    return isAuthorized;
  }
}